<template>
  <div class="q-pa-lg" style="">
    <div>
      <el-form ref="deviceMap" :model="deviceMap":inline="true" size="small">
        <el-form-item>
          <el-input v-model="deviceMap.imei" placeholder="IMEI/设备号" />
        </el-form-item>

        <el-form-item>
          <el-select  clearable filterable allow-create default-first-option v-model="deviceMap.cardType"  placeholder="资源类型">
            <el-option v-for="(item,index) in cardTypes" :key="index" :label="item.cardTypeName" :value="item.cardTypeCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select clearable filterable allow-create default-first-option v-model="deviceMap.agentId" placeholder="代理选择">
            <el-option v-for="(i,index) in agents" :key="index+'q'" :label="i.agentName" :value="i.agentId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select clearable v-model="deviceMap.status" placeholder="卡状态" style="width: 200px">
            <el-option :value="0" label="待激活"/>
            <el-option :value="1" label="正常" />
            <el-option :value="2" label="停机" />
            <el-option :value="3" label="测试激活"/>
            <el-option :value="4" label="测试去激活"/>
            <el-option :value="5" label="已失效"/>
            <el-option :value="6" label="运营商管理状态"/>
            <el-option :value="7" label="拆机"/>
            <el-option :value="8" label="库存"/>
            <el-option :value="9" label="可测试"/>
            <el-option :value="10" label="已清除"/>
            <el-option :value="11" label="已更换"/>
            <el-option :value="12" label="已销户"/>
            <el-option :value="13" label="预销户"/>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" plain size="small" style="padding-left: 10px" @click="list(1)"  icon="el-icon-search">
            搜索
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" plain style="padding-left: 10px;" @click="resetForm()" >
            重置
          </el-button>
        </el-form-item>
        <el-form-item v-if="roleId==='777' || roleId==='619285375'">
          <el-button type="primary" plain size="small"  @click="importCard"  icon="el-icon-upload">导卡
          </el-button>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" plain size="small" @click="outDevice"  icon="el-icon-download">导出</el-button>
        </el-form-item>

        <el-form-item v-if="roleId==='777' || roleId==='619285375' || roleId==='5'" >
          <el-button  type="primary" plain size="small" @click.prevent="allocopen"  icon="el-icon-sold-out">分配套餐</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
              :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight"
              style="width: 100%;margin-top: 1%" border >
      <el-table-column label="ID" prop="id" width="120">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="IMEI" prop="imei" width="150">
        <template slot-scope="scope">
          <div @click="optino_SetMeal(scope.row)"
               style="color: #007aff;text-decoration: underline;cursor: pointer">{{scope.row.imei}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="设备二维码" >
        <el-table-column show-overflow-tooltip label="充值" prop="rechargeCode" width="120">
          <template slot-scope="scope">
            <div class="image-wrapper">
            <img  :src="descPath+scope.row.rechargeCode" class="image" v-if="scope.row.rechargeCode!=null&&scope.row.rechargeCode!=''"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="客服" prop="customerCode" width="120">
          <template slot-scope="scope">
            <div class="image-wrapper">
            <img  :src="descPath+scope.row.customerCode" class="image" v-if="scope.row.customerCode!=null&&scope.row.customerCode!=''"/>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="ICCID" prop="iccid" width="200" v-if="account!=='18714861570'">
        <template slot-scope="{ row }">
          <div v-for="(item, index) in row.iccids.split(',')" :key="index"
               :style="{marginBottom: '5px',paddingBottom: '2px',borderBottom: index < row.iccids.split(',').length - 1 ? '1px solid #ccc' : 'none'}"
          >
            <span style="color: #007aff; display: inline-block; text-align: center;">
              {{item}}
              <img v-if=" row.cardTypes.split(',')[index].endsWith('lt')" style="width:20px; height:20px; vertical-align: middle;" src="../../static/img/lt.png">
              <img v-if=" row.cardTypes.split(',')[index].endsWith('dx')" style="width:20px; height:20px; vertical-align: middle;" src="../../static/img/dx.png">
              <img v-if=" row.cardTypes.split(',')[index].endsWith('yd')" style="width:20px; height:20px; vertical-align: middle;" src="../../static/img/yd.png">
              <span style="margin-left: 5px" v-if="item===row.iccid">默</span>
              <span style="margin-left: 5px" v-else>
                <el-dropdown @command="defaultCard">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color: #007aff"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="beforeDefault(row.imei,item)">设置默认使用卡</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </span>
          </div>
        </template>
      </el-table-column>


      <el-table-column  label="状态变更"  width="100">
        <template slot-scope="scope">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i style="font-size: 18px;color: #007aff" class="el-icon-chat-line-square"></i>
              <i class="el-icon-arrow-down el-icon--right" style="color: #007aff"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="beforeHandle(scope.$index,scope.row,'zc')">在用</el-dropdown-item>
            <el-dropdown-item :command="beforeHandle(scope.$index,scope.row,'tj')">停机</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </template>

      </el-table-column>

      <el-table-column show-overflow-tooltip  label="状态" prop="status" width="100" v-if="account!=='18714861570'">
        <template slot-scope="scope">
          <div v-if="scope.row.networkStatus===0" style="display: inline-flex;width: 100%">
            <div style="width: 8px;height: 8px;background-color: #222933;margin-top: 8%;border-radius: 50%"></div>
            <span style="margin-left: 15%">未激活</span>
          </div>
          <div v-if="scope.row.networkStatus===1" style="display: inline-flex;width: 100%">
            <div style="width: 8px;height: 8px;background-color: green;margin-top: 8%;border-radius: 50%"></div>
            <span style="margin-left: 15%">正常</span>
          </div>
          <div v-if="scope.row.networkStatus===2" style="display: inline-flex;width: 100%">
            <div style="width: 8px;height: 8px;background-color: #fe1611;margin-top: 8%;border-radius: 50%"></div>
            <span style="margin-left: 15%">停机</span>
          </div>


        </template>
      </el-table-column>

      <!--<el-table-column show-overflow-tooltip  label="套餐名称" width="180">
        <template slot-scope="scope">
          <el-button @click="optino_SetMeal(scope.row)" type="primary" round plain size="small">{{scope.row.packageName}}</el-button>
        </template>
      </el-table-column>-->
      <el-table-column show-overflow-tooltip label="代理" prop="agentId" width="100">
      </el-table-column>

      <el-table-column show-overflow-tooltip label="剩余流量" prop="remain" width="100">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="已用用量" prop="usedFlow" width="100">
      </el-table-column>

      <el-table-column show-overflow-tooltip label="在用设备卡信息" v-if="account!=='18714861570'">

        <el-table-column show-overflow-tooltip label="在用卡" prop="iccid" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="运营商" prop="mnc" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.mnc==='4'">移动</div>
            <div v-if="scope.row.mnc==='2'">联通</div>
            <div v-if="scope.row.mnc==='3'">电信</div>
            <div v-if="scope.row.mnc==='6'">广电</div>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="isRealname" label="实名状态" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.isRealname===2">未实名</div>
            <div v-if="scope.row.isRealname===1">已实名</div>
          </template>
        </el-table-column>
      </el-table-column>




      <el-table-column show-overflow-tooltip label="设备参数">
        <!--        <el-table-column show-overflow-tooltip label="软件版本" prop="softwareversion" width="180">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column show-overflow-tooltip label="设备型号" prop="devicemodel" width="180">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column show-overflow-tooltip label="MAC 地址" prop="macaddress" width="180">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column show-overflow-tooltip label="sn 号" prop="sn" width="180">-->
        <!--        </el-table-column>-->

        <el-table-column show-overflow-tooltip label="在线状态" prop="lineStatus" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.isRealname===1">在线</div>
            <div v-if="scope.row.isRealname===2">离线</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="连接数" prop="lineSum" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="wifi 名称" prop="ssid" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="wifi 密码" prop="password" width="180">
        </el-table-column>
      </el-table-column>

      <!--      <el-table-column show-overflow-tooltip label="是否支持实体卡和贴片卡切换" prop="dualSim" width="180">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="scope.row.dualSim===0">只支持单卡</div>-->
      <!--          <div v-if="scope.row.dualSim===1">支持双卡切换</div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column show-overflow-tooltip label="伪断网网络状态" prop="networkStatus" width="180">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="scope.row.networkStatus===0">伪断网</div>-->
      <!--          <div v-if="scope.row.networkStatus===1">网络正常</div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <!--      <el-table-column show-overflow-tooltip label="设备温度" prop="tem" width="180">-->
      <!--      </el-table-column>-->
      <el-table-column show-overflow-tooltip label="导入时间" prop="createTime" width="180">
      </el-table-column>

      <el-table-column fixed="right" width="200" label="操作" v-if="account!=='18714861570'">
        <template slot-scope="scope">
          <el-button @click="openDeviceBox(scope.row,'cut')" plain type="primary" size="mini">切卡
          </el-button>
          <el-button @click="openDeviceBox(scope.row,'up')" plain type="primary" size="mini">修改WIFI
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

    <!--创建资源-->
    <el-dialog v-if="roleId==='777'|| roleId==='619285375'" :close-on-click-modal="false" title="请增加资源所属地区" :visible.sync="diaVisCard" class="class_dialog_hospital" width="50%">
      <el-form :model="resourceForm" :rules="rules" ref="resourceForm">
        <el-form-item label="资源名称" prop="cardTypeName">
          <el-input placeholder="比如：**电信" v-model.trim="resourceForm.cardTypeName" />
        </el-form-item>
        <el-form-item class="wrapper" label="资源代码（注意：此代码为导卡表里面的 card_type）" prop="cardTypeCode">
          <el-input @blur="blurCardType" placeholder="比如：lcdx(聊城电信)" v-model.trim="resourceForm.cardTypeCode" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diaVisCard=false">取 消</el-button>
        <el-button type="primary" @click="saveResource('resourceForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!--导设备入库-->
    <el-dialog v-if="roleId==='777'|| roleId==='619285375'" :close-on-click-modal="false" title="导设备入库" :visible.sync="diaVisImport" class="class_dialog_hospital" width="50%">
      <!--<el-progress :text-inside="true" :stroke-width="20" :percentage="pressnum"></el-progress>-->
      <span>下载模板：<a :href="importUrl">导入模板</a></span>
      <el-upload :disabled="false" ref="upload" style="text-align: center"
                 class="upload-demo" drag
                 :action="uploadUrl"
                 multiple
                 :limit=limitNum :auto-upload="false"
                 :on-change="this.$upload.onChange"
                 :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :headers="headers"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="text-align: center">
        <el-button style="" size="small" plain type="primary" @click="uploadFile">开始上传</el-button>
        <el-button style="" size="small" plain type="info" @click="diaVisImport=false">取消上传</el-button>
      </div>
    </el-dialog>

    <!--设置设备参数-->
    <el-dialog :close-on-click-modal="false" :title="deviceModel.title" :visible.sync="deviceBox"
               class="class_dialog_hospital" width="50%">
      <el-form v-if="deviceModel.val==='up'" :model="deviceModel">
        <el-form-item label="更改WIFI名称" prop="ssid">
          <el-input  v-model="deviceModel.ssid" />
        </el-form-item>
        <el-form-item label="更改WIFI密码" prop="password">
          <el-input  v-model="deviceModel.password" />
        </el-form-item>
      </el-form>

      <el-form style="text-align: center" v-if="deviceModel.val==='cut'" :model="deviceModel">
        <el-form-item>
          <el-button style="width: 500px" @click="deviceModel.cardType='yd',deviceModel.c='cutNet'" type="warning">移动网络</el-button>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 500px" @click="deviceModel.cardType='lt',deviceModel.c='cutNet'" type="warning">联通网络</el-button>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 500px" @click="deviceModel.cardType='dx',deviceModel.c='cutNet'" type="warning">电信网络</el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="deviceBox=false">取 消</el-button>
        <el-button @click="sure()" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <!--导入设备-->
    <el-dialog :close-on-click-modal="false" title="导入设备" :visible.sync="importDeviceBox"
               class="class_dialog_hospital" width="25%">
      <div style="margin-bottom: 2%">
        下载模板：<a :href="importUrl" style="color: #0c9bff;cursor: pointer">点击下载</a>
      </div>
      <el-upload
              ref="uploadRef"
              :before-upload="beforeUpload"
              :on-error="onError"
              :on-success="onSuccess"
              :limit="limit"
              :file-list="fileList"
              class="upload-demo"
              drag
              :action="uploadUrl"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传EXCEL文件</div>
      </el-upload>
    </el-dialog>


    <alloc-package v-if="roleId==='777'|| roleId==='619285375' || roleId==='5'" :append-to-body="true" :diaVisDrawCard="diaVisDrawCard" :key="aollpackey" ></alloc-package>


    <el-dialog
            :visible.sync="taocanBox"
            width="85%"
            :close-on-click-modal="false"
            :append-to-body="true"
    >
      <div style="padding: 50px" v-if="taocanBox">
        <devicePacketDescInfo style="margin-top: -50px" :chuanname="chuanname" :chuaniccid="chuaniccid"></devicePacketDescInfo>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import Pagination from '../../components/pagination'
  import allocPackage from "../../components/alloc_package";
  import devicePacketDescInfo from "./device_packet_desc_info";
  import {crDev, onOffDevice,defaultCard} from "../../api/device";

  export default {
    name: 'equipment',
    components: {
      Pagination,allocPackage,devicePacketDescInfo
    },
    mounted() {
      let _this = this
      _this.loadType()
      _this.loadAgent()
      _this.roleId =_this.$loginUser.roleId
      _this.account=_this.$loginUser.account
      _this.headers={
        token: sessionStorage.getItem("sys-token"),
        userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
      }

    },
    data() {
      return {
        account: '',
        descPath: 'http://' + location.host,
        roleId: '',
        devicejs: require('../../api/device'),
        cardTypeJs: require("../../api/cardType"),
        agentjs: require("../../api/agent"),
        limit:1,
        uploadUrl: process.env.VUE_APP_SERVER + '/manager/device-info/uploadDeviceExcel',
        importUrl: this.$modelUrl+'/设备入库.xlsx',
        importDeviceBox:false,
        tempSim:'',
        cutName:'切换卡槽：',
        imei:'',
        resetFlag:'0',
        restartFlag:'0',
        resetType:'',
        restartType:'',
        mainSim:2,
        deviceBox:false,
        deviceModel:{
          ssid:'',
          password:'',
          val: '',
          imei: '',
          title: '修改参数',
          cardType: "",
          c:""
        },
        statusList:[
          {statusName:'全部',statusValue:'3'},
          {statusName:'未激活',statusValue:'0'},
          {statusName:'在用',statusValue:'1'},
          {statusName:'停机',statusValue:'2'},
        ],
        deviceMap:{
          imei:'',
          cardType:'',
          agentId:'',
          status:'',
          pageNo:1,
          pageSize:10,
        },
        cardTypes:[],
        agents:[],
        diaVisCard: false,
        diaVisImport: false,
        resourceForm: {
          cardTypeName: '',
          cardTypeCode: ''
        },
        rules: {
          cardTypeName: [{ required: true, message: '请输入中文资源名:如济南电信', trigger: 'blur' }],
          cardTypeCode: [{ required: true, message: '例如：电信资源=..dx/移动资源=..yd/联通资源=..lt/广电资源=..gd/设备资源=..sb', trigger: 'blur' }]
        },
        limitNum: 1,
        fileList: [],
        maxHeight: 500,
        tableData: [],
        showShipments: false,
        diaVisDrawCard: false,
        aollpackey: Math.random(100)*100,
        chuaniccid:'',
        chuanname:'',
        taocanBox: false,
      }
    },
    methods: {
      beforeHandle(index,row,c){
        return {
          'index': index,
          'row': row,
          'command': c
        }
      },
      async handleCommand(c){
        let that = this
        let val = c.command
        let data={
          "imei": c.row.imei,
          "c": val
        }
        let res = await onOffDevice(data)
        if(res.data.code==="0"){
          that.$alert(res.data.data)
        }else{
          that.$alert(res.data.msg)
        }
      },
      beforeDefault(imei,iccid){
        return {
          'imei': imei,
          'iccid': iccid
        }
      },
      async defaultCard(c){
        let that = this
        let data={
          "imei": c.imei,
          "iccid": c.iccid
        }
        let res = await defaultCard(data)
        if(res.data.code==="0"){
          that.$alert(res.data.data)
        }else{
          that.$alert(res.data.msg)
        }
      },
      resetForm() {
        this.deviceMap =this.$options.data().deviceMap
      },
      loadAgent(){
        this.agentjs.getSearchAgent(
                {}).then(res=>{
          res.data.data.map(item=>{
            let map={
              agentId: item.agentId,
              agentName: item.agentName
            }
            this.agents.push(map)
          })

        })
      },
      loadType() {
        let _this = this
        _this.cardTypeJs.getDeviceCardTypeList().then(response => {
          _this.cardTypes = response.data.data
        })
      },
      importCard() {
        this.$confirm('当前要导入的这批卡是否已经存在过资源?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        })
                .then(() => {
                  this.diaVisCard = false
                  this.diaVisImport = true
                })
                .catch(() => {
                  this.diaVisCard = true
                  this.diaVisImport = false
                })
      },
      saveResource(form) {
        let _this = this
        if (!_this.blurCardType()) {
          _this.$alert('资源编码格式错误')
          return false
        }
        _this.$refs[form].validate(valid => {
          if (valid) {
            _this.cardTypeJs.saveCardType( _this.resourceForm).then(res => {
              if (res.data.code === '0') {
                _this.$alert('新建资源成功，即将跳转上传导卡...')
                _this.diaVisCard = false
                setTimeout(function () {
                  _this.diaVisImport = true
                }, 3000)
              } else {
                _this.$alert(res.data.msg)
              }
              _this.$refs.upload.clearFiles()
            })
          } else {
            _this.$alert('表单验证失败')
            _this.$refs.upload.clearFiles()
            return false
          }
        })
      },
      blurCardType() {
        let _this = this
        let len = _this.resourceForm.cardTypeCode.length
        let str = _this.resourceForm.cardTypeCode.substr(len - 2, len)
        if (str !== 'dx' && str !== 'yd' && str !== 'lt' && str !== 'gd'&& str !== 'sb') {
          _this.$notify.error('资源编码最后请以运营商小写字母结束！')
          return false
        }
        return true
      },
      async outDevice(){
        let _this = this
        if (_this.$check.checkIsNull(_this.deviceMap.cardType)) {
          if (_this.$check.checkIsNull(_this.deviceMap.imei)) {
            _this.$alert('请先选择资源通道！')
            return false
          }
        }
        _this.$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deviceMap.pageNo =1
          this.deviceMap.pageSize = _this.$refs.pagination.size
          _this.devicejs.exportExcel( this.deviceMap)
                  .then(res => {
                    _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
                  })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
      },
      optino_SetMeal(info) {
        //套餐操作
        let _this = this
        _this.chuaniccid =info.imei
        _this.chuanname=info.packageAgentname
        _this.taocanBox =true
      },
      allocopen(){
        this.aollpackey =this.aollpackey +1
        this.diaVisDrawCard = true
      },
      onExceed(files,fileList){
        if(!onExcced(files,fileList)){
          return false
        }

      },
      onSuccess(res,file,fileList){
        if(res.code==='0'){
          this.$alert(res.data,'成功')
        }else{
          this.$alert(res.msg.substr(0,30),'失败')
        }
        this.$refs.uploadRef.clearFiles()
        this.list(1)
      },
      onError(err,file,fileList){
        this.$alert(err,'失败')
      },
      beforeUpload(file){
        if(!this.$upload.beforeUpload(file)){
          return false
        }

      },
      importDevice(){
        let that=this
        that.importDeviceBox=true
      },
      async sure(){
        let that=this
        let res = await crDev(that.deviceModel)
        if(res.data.code==="0"){
          that.$alert(res.data.data)
        }else{
          that.$alert(res.data.msg)
        }
      },
      cutBtn(cutsim){
        let that=this
        if(cutsim===that.mainSim){
          that.$alert('当前卡槽正在使用，请切换另外的卡槽','切换失败')
          return false
        }
        that.deviceModel.isCutSim=cutsim
        that.tempSim =cutsim
      },
      resetDevice(){
        if(this.restartFlag==='1'){
          this.$alert('重置和重启只能同时设置一个参数！', '设置失败', {
            confirmButtonText: '确定'
          });
          return false
        }
        if(this.resetFlag==='0'){
          this.resetFlag='1'
          this.resetType='primary'
          this.deviceModel.isReset=1
        }else{
          this.resetFlag='0'
          this.resetType=''
          this.deviceModel.isReset=0
        }
      },
      restartDevice(){
        if(this.resetFlag==='1'){
          this.$alert('重置和重启只能同时设置一个参数！', '设置失败', {
            confirmButtonText: '确定'
          });
          return false
        }
        if(this.restartFlag==='0'){
          this.restartFlag='1'
          this.restartType='primary'
          this.deviceModel.isRestart=1
        }else{
          this.restartFlag='0'
          this.restartType=''
          this.deviceModel.isRestart=0
        }
      },
      openDeviceBox(row,val){
        let that=this
        that.deviceModel.imei=row.imei
        that.deviceModel.val = val
        if(val==="cut"){
          that.deviceModel.title="切换网络"
        }else{
          that.deviceModel.title="修改WIFI"
          that.deviceModel.c='upWifi'
        }
        that.deviceBox=true
      },
      list(page) {
        let _this = this
        _this.maxHeight = _this.$listenHeight.getBodyHeight()

        _this.tableData = []
        _this.deviceMap.pageNo=page
        _this.deviceMap.pageSize=_this.$refs.pagination.size
        _this.devicejs.queryDeviceList(_this.deviceMap).then(res => {
          if (res.data.code === '0') {
            _this.tableData = res.data.data.rows
            _this.$refs.pagination.render(page, res.data.data.total)
          } else {
            this.$message.warning(res.msg)
          }
        }).catch(err=> {
          this.$message.warning(res.msg)
        })
      },

      // 文件上传成功时的钩子
      handleSuccess(res, file, fileList) {
        let _this = this
        clearInterval(_this.timer)
        if (res.code === '0') {
          this.$alert(res.data)
          this.diaVisImport=false
        } else {
          this.$alert(res.msg)
          this.$refs.upload.clearFiles()
        }
      },
      // 文件上传失败时的钩子
      handleError(err, file, fileList) {
        let _this = this
        clearInterval(_this.timer)
        this.alert.error('文件上传失败')

        this.$refs.upload.clearFiles()
      },
      uploadFile() {
        this.$refs.upload.submit()
      },
    }
  }
</script>

<style lang="css" >
  .el-tooltip__popper {
    max-width: 70%;
  }
</style>
<style scoped>
  .image {
    width: 50px; /* 原始宽度 */
    height: 50px; /* 原始高度 */
  }

  .image-wrapper:hover .image {
    width: 500px; /* 原始宽度 */
    height: 500px; /* 原始高度 */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  /*滚动条样式*/
  /deep/ ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  /deep/ ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    box-shadow: inset 5px 0px 5px #f0f0f0;
    background: #d9d9d9;
  }
  /deep/ ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px #f0f0f0;
    border-radius: 8px;
    background: #ffffff;
  }

  /deep/.el-table .el-table__cell {
    padding: 9px;
  }
  /deep/thead.has-gutter {
    height: 40px;
  }
</style>
<style scoped>
  .box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  /deep/ .el-main {
    text-align: left;
    padding: 20px !important;
    overflow: hidden !important;
  }
  .active{
    border: 1px solid #66b1ff;
    width: 56px;
    height: 28px;
    line-height: 1.5rem;
    border-radius: 4px;
    text-align: center;
    background-color: #66b1ff;
    color: #fff;
    margin-right: 10px;
  }
  .btn{
    border: 1px solid #23241f;
    width: 56px;
    height: 28px;
    line-height: 1.5rem;
    border-radius: 4px;
    text-align: center;
    background-color: white;
    color: black;
    margin-right: 10px;

  }
  /* --------------------------弹窗样式------------------------------ */
  /*标题样式*/
  /deep/.class_dialog_hospital .el-dialog__title {
    font-size: 15px;
    margin-left: 15px;
  }

  /*头区样式*/
  /deep/.class_dialog_hospital .el-dialog__header {
    height: 50px;
    background: #e6e6e6;
    padding: 15px 0 4px 10px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }

  /*头区退出按钮样式*/
  /deep/.class_dialog_hospital .el-dialog__headerbtn {
    top: 14px;
    right: 20px;
    font-size: 16px;
  }

  /*对话框区*/
  /deep/.class_dialog_hospital .el-dialog {
    border: 1px solid #dcdfe6;
    box-shadow: 0 0 4px #e6e6e6;
    border-radius: 9px;
    padding: 0;
  }

  /*内容区*/
  /deep/.class_dialog_hospital .el-dialog__body {
    padding: 20px;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #333;
    font-weight: 700;
  }

  /*脚区*/
  /deep/.class_dialog_hospital .el-dialog__footer {
    border-top: 2px solid #e8eaec;
    padding: 16px;
  }
</style>